import Keycloak from 'keycloak-js';

/**
 * All user roles (realm + resource), equivalent to the legacy
 * `KeycloakService.getUserRoles()`. Returns a unique list of role names.
 */
export function getUserRoles(keycloak: Keycloak): string[] {
  const realmRoles = keycloak.realmAccess?.roles ?? [];
  const resourceRoles = Object.values(keycloak.resourceAccess ?? {}).flatMap(
    (resource) => resource.roles ?? []
  );
  return Array.from(new Set([...realmRoles, ...resourceRoles]));
}
